import routes from 'routes/tenants'

const Tenants = () =>
  routes

export default Tenants
